import { useState } from "react";
import { Share2, Link2, Check, Facebook, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const ShareButton = ({ title = "SkillCity", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch {}
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Ο σύνδεσμος αντιγράφηκε");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Αποτυχία αντιγραφής");
    }
  };

  const enc = encodeURIComponent(url);
  const encT = encodeURIComponent(title);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="share-button"
          className={`h-11 w-11 grid place-items-center rounded-full border border-border bg-white hover:bg-muted transition-colors ${className}`}
          aria-label="share"
          onClick={() => { if (navigator.share && window.innerWidth < 768) nativeShare(); }}
        >
          <Share2 size={18} className="text-slate-600" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem onClick={copy} data-testid="share-copy">
          {copied ? <Check size={16} className="mr-2 text-green-600" /> : <Link2 size={16} className="mr-2" />} Αντιγραφή συνδέσμου
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${enc}`} target="_blank" rel="noopener noreferrer" data-testid="share-facebook"><Facebook size={16} className="mr-2" /> Facebook</a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={`https://wa.me/?text=${encT}%20${enc}`} target="_blank" rel="noopener noreferrer" data-testid="share-whatsapp"><MessageCircle size={16} className="mr-2" /> WhatsApp</a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={`viber://forward?text=${encT}%20${enc}`} data-testid="share-viber"><MessageCircle size={16} className="mr-2" /> Viber</a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
